import axios from 'axios';
import baseService from '../shared/baseService';

const stilingueSpreadsheetService = () => baseService('social-medias/stilingue-spreadsheets');
const postSpreadsheet = (userId: number, params: FormData) =>
    axios.post(`social-medias/stilingue-spreadsheets/${userId}/`, params, {headers: {'Content-Type': 'multipart/form-data'}} );

export default {
    stilingueSpreadsheetService,
    postSpreadsheet
};
